function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreatBritain = function SvgGreatBritain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.33 512 341.337",
    style: {
      enableBackground: "new 0 85.33 512 341.337"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052b4"
    },
    d: "M393.785 315.358 512 381.034v-65.676zM311.652 315.358 512 426.662v-31.474l-143.693-79.83zM458.634 426.662l-146.982-81.664v81.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052b4"
    },
    d: "M90.341 315.356 0 365.546v-50.19zM200.348 329.51v97.151H25.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M143.693 315.358 0 395.188v31.474l200.348-111.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052b4"
    },
    d: "M118.215 196.634 0 130.958v65.676zM200.348 196.634 0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052b4"
    },
    d: "M421.659 196.636 512 146.446v50.19zM311.652 182.482V85.331h174.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M368.307 196.634 512 116.804V85.33L311.652 196.634z"
  }));
};
export { SvgGreatBritain as ReactComponent };
export default "data:image/svg+xml;base64,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";